import root from './_root.js';

/** Built-in value references. */
var Reflect = root.Reflect;

export default Reflect;
